import { render, staticRenderFns } from "./ExamineeTermsAndConditions.vue?vue&type=template&id=5a7c12d4&scoped=true&"
import script from "./ExamineeTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./ExamineeTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeTermsAndConditions.vue?vue&type=style&index=0&id=5a7c12d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c12d4",
  null
  
)

export default component.exports